export const ORIGEN_KEYS = ['instalador', 'cliente']
